import React from "react";

// 32 narrow fabric sections share one undistorted flag drawing. Static wave
// samples become compositor transforms; no frame loop, canvas or SVG filters.
export function WavingRepublicFlag() {
  const id = React.useId().replace(/:/g, "");
  const clothId = `republic-cloth-${id}`;
  const moonId = `republic-moon-${id}`;
  const sections = Array.from({ length: 32 }, (_, i) => {
    const x = i * 300 / 32;
    const style = {};
    for (let phase = 0; phase < 4; phase += 1) {
      const angle = x / 170 * Math.PI * 2 - phase * Math.PI / 2;
      const amplitude = 15 * x / 300;
      const slope = 15 / 300 * Math.sin(angle) + amplitude * Math.PI * 2 / 170 * Math.cos(angle);
      style[`--wave-${phase}`] = `${(Math.sin(angle) * amplitude).toFixed(3)}px`;
      style[`--tilt-${phase}`] = `${(Math.atan(slope) * 180 / Math.PI).toFixed(3)}deg`;
      style[`--shade-${phase}`] = (0.05 + (1 - Math.cos(angle)) * 0.12).toFixed(3);
    }
    return <g key={i} transform={`translate(${30 + x} 30)`}>
      <g className="republic-cloth-section" style={style}>
        <svg width={300 / 32 + 0.35} height="200" viewBox={`${x} 0 ${300 / 32 + 0.35} 200`} overflow="hidden">
          <use href={`#${clothId}`} />
          <rect className="republic-cloth-shadow" x={x} width={300 / 32} height="200" fill="#160004" />
        </svg>
      </g>
    </g>;
  });
  return <div className="republic-grand-flag" data-testid="republic-waving-flag">
    <svg viewBox="0 0 365 270" className="republic-flag-fabric">
      <defs>
        <mask id={moonId}>
          <rect width="300" height="200" fill="black" />
          <circle cx="110" cy="100" r="50" fill="white" />
          <circle cx="122.5" cy="100" r="40" fill="black" />
        </mask>
        <g id={clothId}>
          <rect width="300" height="200" fill="#e30a17" />
          <rect width="300" height="200" fill="#fff" mask={`url(#${moonId})`} />
          <path d="m172 75 5.61 17.27h18.16l-14.69 10.67 5.61 17.27L172 109.54l-14.69 10.67 5.61-17.27-14.69-10.67h18.16Z" fill="#fff" transform="rotate(18 172 100)" />
        </g>
        <linearGradient id={`pole-${id}`}>
          <stop stopColor="#777b81" /><stop offset=".45" stopColor="#f0e8d5" /><stop offset="1" stopColor="#5d626a" />
        </linearGradient>
      </defs>
      <rect x="24" y="20" width="5" height="248" rx="2" fill={`url(#pole-${id})`} />
      <circle cx="26.5" cy="16" r="6" fill="#c4b28b" />
      {sections}
      <path d="M30 30v200" stroke="#a90819" strokeWidth="3" />
    </svg>
  </div>;
}

export function RepublicBackdrop({ quiet = false }) {
  return <div className="republic-backdrop" data-quiet={quiet} aria-hidden="true" data-testid="republic-backdrop">
    <div className="republic-artwork" />
    <div className="republic-mobile-portrait" />
    <div className="republic-vignette" />
    <WavingRepublicFlag />
  </div>;
}

export function RepublicCelebration() {
  return <section className="republic-celebration" aria-label="29 Ekim Cumhuriyet Bayramımız kutlu olsun">
    <p className="republic-eyebrow">1923 · İLELEBET CUMHURİYET</p>
    <h2><span className="republic-date">29 EKİM</span><span className="republic-word">CUMHURİYET</span></h2>
    <p className="republic-greeting">BAYRAMIMIZ KUTLU OLSUN</p>
    <span className="republic-title-rule" aria-hidden="true" />
  </section>;
}
